<template>
<svg version="1.1" class="-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 28 20" height="50px" style="enable-background:new 0 0 22 22;" xml:space="preserve">
  <path fill="#182D4C"  d="M13.69,16.31v-2.5H7.48V7.87h-2.5v-2.5H2.49v9.7c0,2.06,1.68,3.74,3.74,3.74h9.96v-2.49H13.69z"/>
  <path fill="#DD1874"  d="M14.94,2.88H4.98v4.99h8.71v8.45h4.99v-9.7C18.68,4.56,17,2.88,14.94,2.88z"/>
</svg>
</template>
